var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15V8C9.5 7.17157 8.82843 6.5 8 6.5V6.5C7.17157 6.5 6.5 7.17157 6.5 8V8",
    stroke: "#022B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16V8C14.5 7.17157 13.8284 6.5 13 6.5V6.5C12.1716 6.5 11.5 7.17157 11.5 8V8",
    stroke: "#022B54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.5H9.5",
    stroke: "#022B54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.4995C17.5 14.4995 16.5 15.5004 14.5 15.5C12.5 15.4996 11.5 14.4995 9.5 14.5C7.5 14.5005 6.5 15.4995 6.5 15.4995",
    stroke: "#022B54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.5C17.5 16.5 16.5 17.501 14.5 17.5005C12.5 17.5001 11.5 16.5 9.5 16.5005C7.5 16.5011 6.5 17.5 6.5 17.5",
    stroke: "#022B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPool);
export default __webpack_public_path__ + "static/media/pool.e57d16490bcd85f652bf3c18c16da3a6.svg";
export { ForwardRef as ReactComponent };